import React, { useState } from 'react'
import FlcLogo from 'Assets/Images/TAS.png'
import { InputField } from 'JsUtils/FormikControls';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import LockdIcon from '@mui/icons-material/Lock';
import styles from './index.module.scss'
import Button from '@mui/material/Button';
import { Container } from '@mui/material';
import { strengthColorIndicator } from 'JsUtils/StrengthColorIndicator';
import checkPasswordStrength from 'check-password-strength'


const passwordStrengthOptions = [
    {
        id: 1,
        value: "Weak",
        minDiversity: 0,
        minLength: 6
    },
    {
        id: 2,
        value: "Medium",
        minDiversity: 4,
        minLength: 10
    },
    {
        id: 3,
        value: "Strong",
        minDiversity: 4,
        minLength: 12
    }
]

const ChangePasswordForm = () => {
    const [showPassword, setshowPassword] = useState(false)
    const [passwordStrengthIndicator, setpasswordStrengthIndicator] = useState('')
    const [showConfirmPassword, setshowConfirmPassword] = useState(false)


    const handleClickShowPassword = () => {
        setshowPassword(!showPassword)
    }

    const handleClickConfirmShowPassword = () => {
        setshowConfirmPassword(!showConfirmPassword)
    }

    // FORMIK INITIAL VALUES
    const initialValues = {
        password: '',
    }

    // YUP VALIDATION SCHEMA
    const validationSchema = Yup.object({
        password: Yup.string()
            .required('Please Enter A Password'),
        confirmPassword: Yup.string()
            .required('Password Confirmation is Required')
            .oneOf([Yup.ref('password')], 'Password Does Not Match'),
    })

    // HANDLE SUBMIT
    const HandleSubmit = (values) => {
        // console.log(values)
    }

    return (
        <Container maxWidth='xs' className={styles.mainContainer}>
            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={HandleSubmit}>
                {(formikProps) => (
                    <Form >
                        <div className={styles.wrapper}>
                            <img src={FlcLogo} alt="FLC" height={'60px'} />
                            <h2>LETS'S CONNECT</h2>
                        </div>

                        <div className={styles.description}>
                            <h3>Change Password</h3>
                            <p>Input your new desired password in the input fields below to create a new password.
                                We strongly advise you to store it safely.
                            </p>
                        </div>

                        <hr />

                        {/* PASSWORD */}
                        <div className={styles.inputContainer}>
                            <InputField
                                name="password"
                                type={showPassword ? "text" : "password"}
                                placeholder="Password *"
                                className={styles.inputField}
                                maxLength={50}
                                adornment={<LockdIcon />}
                                endAdornment={true}
                                showPassword={showPassword}
                                handleClickShowPassword={handleClickShowPassword}
                                onChange={(e) => {
                                    formikProps.setFieldValue('password', e.target.value)
                                    const password = e.target.value
                                    if (password === '') {
                                        setpasswordStrengthIndicator('')
                                    }
                                    else {
                                        setpasswordStrengthIndicator(checkPasswordStrength.passwordStrength(password, passwordStrengthOptions).value)
                                    }
                                }}
                            />
                            <h5 style={strengthColorIndicator(passwordStrengthIndicator)}>
                                {passwordStrengthIndicator && `Password Strength ${passwordStrengthIndicator}`}
                            </h5>
                        </div>

                        {/* CONFIRM PASSWORD */}
                        <div className={styles.inputContainer}>
                            <InputField
                                name="confirmPassword"
                                type={showConfirmPassword ? "text" : "password"}
                                placeholder="Confirm Password *"
                                className={styles.inputField}
                                maxLength={50}
                                adornment={<LockdIcon />}
                                endAdornment={true}
                                showPassword={showConfirmPassword}
                                handleClickShowPassword={handleClickConfirmShowPassword}
                            />
                        </div>

                        <div>
                            <Button sx={{ background: '#0A48B3', width: '100%', padding: '10px' }} type='submit' variant="contained">CHANGE PASSWORD</Button>
                        </div>

                        <div className={styles.footer}>
                            <p>Do You Need Help?</p>
                            <h5>Customer Support</h5>
                        </div>
                    </Form>
                )
                }
            </Formik>
        </Container>
    );
}
export default ChangePasswordForm;